import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1f3a132e"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Stars: require('/vercel/path0/components/Stars.vue').default})
